// --mayur code for insurance start--
  //var insurance_product_id = 7653202624709;
  //var insurance_product_variant_id = 42886817906885;

 var insurance_product_id = insurance_meta_object.product_id;
 var insurance_product_variant_id = 42886817906885;
 
  
$(document).ready(function(){

    var parInt = $('.customizer_validation, .customizer_validation_block .option-value-input:checked, .customizer_validation_number, .customizer_validation_number_block .option-value-input:checked').val();
    if ($('.customizer_validation, .customizer_validation_block .option-value-input:checked, .customizer_validation_number, .customizer_validation_number_block .option-value-input').length > 0 && !isNaN(parInt)) {
      var max_val = parseInt(parInt); 
      $('.product-customizer-option [type="text"]').attr('maxlength', max_val).val('');
    }

    function letterRender(){ 
    var firstCharacter = $('.option-value-input[data-option="Letters"]:checked').val();
    // var firstCharacter = selected_count.charAt(0).toString();
    
      if (!isNaN(firstCharacter)) {
        $('.custom_script').prop('maxlength',firstCharacter);
      }
    $('body').on('change','.option-value-input[data-option="Letters"]',function(){
      var latter_counts = $(this).val();
      // var firstCharacter = latter_counts.charAt(0).toString();
      $('.custom_script').val('');
      if (!isNaN(latter_counts)) {
        $('.custom_script').prop('maxlength',latter_counts);
      }
    });  
    }
  
    if($('.option-value-input[data-option="Letters"]').length > 0){
      letterRender();
    }
  
    $('body').on('keyup','.custom_script',function(){
     var val = $(this).val();
     console.log(val); 
     $(this).next('.result_wrrap').find('.custom_result').text(val);
    });

let activeInput = null;

// Track active input on focus or typing
$('body').on('focus input', '.custom_script', function () {
    let hebrew_font_box = $('.hewbrew-container').length;
    if(hebrew_font_box > 0){
      activeInput = $(this);

      // Enforce total limit when typing manually
      var $customScripts = $('.custom_script');
      var totalLimit = parseInt($customScripts.attr('maxlength'));

      // Count total characters
      var totalEntered = 0;
      $customScripts.each(function () {
          totalEntered += $(this).val().length;
      });

      // If over the limit, trim the current input
      if (totalEntered > totalLimit) {
          var allowedForThis = totalLimit - (totalEntered - $(this).val().length);
          $(this).val($(this).val().substring(0, allowedForThis));
      }
    }
});

// Hebrew letter click handler
$('body').on('change', '.hebrew-element input[type="radio"]', function () {
    var $customScripts = $('.custom_script');
    var totalLimit = parseInt($customScripts.attr('maxlength'));

    // If no active input yet, and both inputs are blank → default to first one
    if (!activeInput) {
        var allBlank = true;
        $customScripts.each(function () {
            if ($(this).val().trim() !== '') {
                allBlank = false;
                return false;
            }
        });
        if (allBlank) {
            activeInput = $customScripts.eq(0);
        }
    }

    if (!activeInput) return; // Still no target input

    // Count total chars across both inputs
    var totalEntered = 0;
    $customScripts.each(function () {
        totalEntered += $(this).val().length;
    });

    if (totalEntered >= totalLimit) return; // Stop if max reached

    $('.hebrew-label').removeClass('selected');
    $(this).closest('.hebrew-element').find('.hebrew-label').addClass('selected');

    var hebrew_letter = $(this).val();
    var spaceLeftGlobal = totalLimit - totalEntered;
    var currentLength = activeInput.val().length;
    var spaceLeftThisInput = spaceLeftGlobal > 0 ? spaceLeftGlobal : 0;

    if (spaceLeftThisInput > 0 && currentLength < totalLimit) {
        var textToAdd = hebrew_letter.substring(0, spaceLeftThisInput);
        activeInput.val(activeInput.val() + textToAdd);
    }
});





    var selected_swatch = $('.form-options-swatches .option-value-input:checked').attr('data-color');
    $('.custom_result').addClass(selected_swatch);
    
    $('body').on('change','.form-options-swatches .option-value-input',function(){
      var color_swatch = $(this).attr('data-color');
      $('.custom_result').removeClass().addClass('custom_result ' + color_swatch);
    });
  
  if ($('.customizer_validation').length > 0) {
    $('.customizer_validation').find('option').sort(function(a, b) {
      return +a.value - +b.value;
    }).appendTo('.customizer_validation');
    // $(".customizer_validation").val($(".customizer_validation option:first").val());
  }
  $('.slideshow-banner-index .home-slide').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: true
      }
    }
  ]
  });
  $('.related-products--container ul.product-section--content:not(.cart_pro_list)').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    }
  ]
  });

$('.cart-recommendation-container ul.cart_pro_list').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    }
  ]
  });
  
//   $('[data-newgallery-navigation]').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: true,
//     asNavFor: '[data-newgallery-viewer]'
//   });
//   $('[data-newgallery-viewer]').slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     asNavFor: '[data-newgallery-navigation]',
//     dots: true,
//     centerMode: true,
//     focusOnSelect: true
//   });

  function backimg_head_border(){
    if($('.back-image-with-text-container').length > 0){
      $('.back-image-with-text-container').each(function(){
        var main = $(this).offset().top;
        var head = $(this).find('.alt-img-with-text--text .heading').offset().top;
        var offset = head-main+$(this).find('.alt-img-with-text--text .heading ').outerHeight();
        $(this).append('<style>.back-image-with-text--section .back-image-with-text-container:before{top: '+offset+'px }</style>');
      });
    }
  }
  backimg_head_border();
  $(window).resize(function(){
    backimg_head_border();
  });
  
  var slideWrapper = $('.slideshow-banner-index .home-slide');
  function videoStat(slick) {
    var currentSlide = slick.find(".slick-current");
    var slideType = currentSlide.attr('data-slide-type');
    if (slideType === "youtube") {
      var pl = currentSlide.find("iframe").get(0);
      var fid = $(pl).attr('id');
      var ik_player = new YT.Player(fid);
      ik_player.addEventListener("onStateChange", function(state){
        if(state.data == 0 || state.data == 2){
          slideWrapper.slick("slickNext");
          slideWrapper.slick('slickPlay');
        }
      });
    } else if (slideType === "hvideo") {
      var pl = currentSlide.find("video").get(0);
      pl.onended = function(e) {
        slideWrapper.slick("slickNext");
        slideWrapper.slick('slickPlay');
      };
      pl.onpause = function() {
        slideWrapper.slick("slickNext");
        slideWrapper.slick('slickPlay');
      }; 
    }

    
  }

  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  function playPauseVideo(slick, control){

    var currentSlide, slideType, startTime, player, video;
    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.find('.video_wp').attr('data-slide-type');
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");      
    if (slideType === "youtube") {
      switch (control) {
        case "play":
          slideWrapper.slick('slickPause');
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "hvideo") {
      video = currentSlide.find("video").get(0);
      if (video != null) {
        if (control === "play"){
          slideWrapper.slick('slickPause');
          video.play();
        } else {
          video.pause();
          slideWrapper.slick("slickNext");
          slideWrapper.slick('slickPlay');
        }
      }
    }
    else if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    }
  }
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
    videoStat(slick);

  });

  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
      videoStat(slick);
    }, 2000);
  });


  $('.product-list-slider-wp .productgrid--items').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,  
    arrows: true,
    swipeToSlide: true,  
    touchThreshold: 30,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0361/6525/files/Carousel_Arrow-Left_edb105ff-1a5b-4a67-95c6-97479b00b6aa.svg?v=1785411910"/></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0361/6525/files/Carousel_Arrow-Right_4f5b2e73-df0c-479c-a1bd-0d5abed57da9.svg?v=1785411624"></button>',
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          touchThreshold: 30
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          touchThreshold: 30
        }
      }
    ]
  });

  $('body').on('click','.pdp_tab .tab-title',function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    if($(this).hasClass('active')){
      $('.pdp_tab').find('.tab-title').removeClass('active');
      $('.pdp_tab').find('.tab-content').slideUp();
    }else{
      $('.pdp_tab').find('.tab-title').removeClass('active');
      $('.pdp_tab').find('.tab-content').slideUp();
      $(this).addClass('active');
      $('.pdp_tab').find(id).slideDown();
    }
  });
  $('body').on('click','.quickshop_modal_wrapper .tab-title',function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    if($(this).hasClass('active')){
      $('.quickshop_modal_wrapper').find('.tab-title').removeClass('active');
      $('.quickshop_modal_wrapper').find('.tab-content').slideUp();
    }else{
      $('.quickshop_modal_wrapper').find('.tab-title').removeClass('active');
      $('.quickshop_modal_wrapper').find('.tab-content').slideUp();
      $(this).addClass('active');
      $('.quickshop_modal_wrapper').find(id).slideDown();
    }
  });
       
//   function check_product_wishlist(){
//     if($('.custom_wishlist_btn').length > 0){
//       if($('.custom_wishlist_btn').hasClass('swym-iconbtnlink')){
//         $('.mobile-wishlist-icon .custom_wishlist_btn_mob').html($('.custom_wishlist_btn').html());
//         if($('.custom_wishlist_btn').hasClass('swym-added')){
//           $('.mobile-wishlist-icon .custom_wishlist_btn_mob').addClass('swym-added');
//         }else{
//           $('.mobile-wishlist-icon .custom_wishlist_btn_mob').removeClass('swym-added');
//         }
//       }else{
//         setTimeout(function(){
//           check_product_wishlist();
//         },1000);
//       }
//     }
//   }
//   check_product_wishlist();
//   $(window).resize(function(){
//     check_product_wishlist();
//   });
//   $('body').on('click','.mobile-wishlist-icon .custom_wishlist_btn_mob',function(e){
//     e.preventDefault();
//     $('[data-swaction="addToWishlist"]').trigger('click');
//     setTimeout(function(){
//       check_product_wishlist();
//     },1200);
//   });
  var total_h = 0;
  $(".gallery-navigation--scroller [data-gallery-thumbnail]").each(function(ee,vv){
    total_h = total_h + $(this).outerHeight();
  });
  total_h = total_h;
  function scroll_hide_btn(st,total_h){
    if(st < 4){
      $(".gallery-navigation--scroll-button.scroll-left").hide();
    }else{
      $(".gallery-navigation--scroll-button.scroll-left").show();
    }
    if($('.gallery-navigation--scroller').scrollTop() + $('.gallery-navigation--scroller').height() < total_h){
      $(".gallery-navigation--scroll-button.scroll-right").show();
    }else{
      $(".gallery-navigation--scroll-button.scroll-right").hide();
    }
  }
  $(".gallery-navigation--scroller").scroll(function(){
    scroll_hide_btn($(this).scrollTop(),total_h);
  });
  scroll_hide_btn(0,total_h);
  $('body').on('click', '.gallery-navigation--scroller [data-gallery-thumbnail]',function(e){
    e.preventDefault();
    var height = 0;
    if(Number($(this).attr('data-gallery-index')) == 0){
      height = 0;
    }else if(Number($(this).attr('data-gallery-index')) == ($('.gallery-navigation--scroller [data-gallery-thumbnail]').length - 1)){
      height = $('.gallery-navigation--scroller').outerHeight();
    }else{
      height = $(this).offset().top - 30;
    }
    $('.gallery-navigation--scroller').scrollTop(height);
  });
  
  
  function change_default_image($this){
    var default_img = $this.parents('li.productgrid--item').find('.productitem--image .productitem--image-alternate').attr('src');
    var default_img_main = $this.parents('li.productgrid--item').find('.productitem--image .productitem--image-primary').attr('src');
    $this.parents('li.productgrid--item').find('.productitem--image .productitem--image-alternate').attr('srcset',default_img);
    $this.parents('li.productgrid--item').find('.productitem--image .productitem--image-primary').attr('srcset',default_img_main);
  }
//   function get_json_swatch_image(val,$this,href){
   
//   $.get(href+"?view=_swatch-data", function( data ) {

//       var sdata = JSON.parse($(data).find('.swatch-data').html());
//       var swad = sdata.swatches;
     
//       for(var i=0;i<swad.length;i++){
//         var dd = swad[i].swatchValue;
//         if(val == dd){
          
//           $this.parents('li.productgrid--item').find('.productitem--image .productitem--image-alternate').attr('srcset',swad[i].variant_img);
//           $this.parents('li.productgrid--item').find('.productitem--image .productitem--image-primary').attr('srcset',swad[i].variant_img);
//         }
//       }
//     });
//   }
  
// $('body').on('mouseover','[data-swatches] label',function(){
// var val = $(this).find('input').val();
//   var $this = $(this);
//   var href = $this.parents('li.productgrid--item').find('.productitem--image-link').attr('href');
//   get_json_swatch_image(val,$this,href);
  
// });
  
// $('body').on('change','.productitem--swatches-container input[type="radio"]',function(e){
//   e.preventDefault();
//     var val = $(this).val();
//     var $this = $(this);
//     var href = $this.parents('li.productgrid--item').find('.productitem--image-link').attr('href');
//     get_json_swatch_image(val,$this,href);
// });

// $('body').on('mouseleave','.product-list-slider-wp .productitem--swatches-container',function(){
//   console.log($(this).find('.productitem--swatches-input:checked').length);
//   if($(this).find('.productitem--swatches-input:checked').length < 1 ){
//     change_default_image($(this));
//   }else{
//     var val = $(this).find('.productitem--swatches-input:checked').val();
//     var $this = $(this);
//     var href = $this.parents('li.productgrid--item').find('.productitem--image-link').attr('href');
//     get_json_swatch_image(val,$this,href);
//   }
// });
  $('body').on('click', '.gallery-navigation--scroller [data-gallery-scroll-button]',function(e){
    e.preventDefault();
    console.log('aaa');
    if($(this).hasClass('scroll-left')){
      console.log('bbb');
      $('.gallery-navigation--scroller[data-gallery-thumbnail][data-gallery-selected="true"]').prev().trigger('click');
    }else{
      console.log('ccc');
      $('.gallery-navigation--scroller[data-gallery-thumbnail][data-gallery-selected="true"]').next().trigger('click');
    }
  });
  function on_load_img_height(){
    if($('.productgrid--item').length > 0){
      var pr_img_height = $('[data-product-item-content] [data-product-page-link]').outerHeight();
      var pr_btn_height = $('.productitem--action').outerHeight();
      var main_height = pr_img_height - pr_btn_height;
//         console.log('hihihi');
//         console.log(main_height+'****');
      $(' .productitem--actions').css('top', main_height+'px');
    }else{
      setTimeout(function(){
        on_load_img_height();
      },1000);
    }
  }
  $(window).on('load resize orientationchange', function() {
    on_load_img_height();
  });
    
  $(window).on('load', function() {

    function country_switcher_popup(){
      if($('.gep-switcher').length > 0){
        var popup = $('.gep-switcher').html();
        var this_class = $('.gep-switcher').attr('class');
        var html = '<div class="'+this_class +'">'+popup+'</div>';
        if($(window).width() > 850){
          $('.app_shipping_to.for_mobile').hide();
          $('.app_shipping_to.for_dekstop').html(html);  
        }else{
          $('.app_shipping_to.for_dekstop').hide();
          $('.app_shipping_to.for_mobile').html(html);
        }
        
      }else{
        setTimeout(function(){
          country_switcher_popup();
        },1000);
      }
    }
    country_switcher_popup();
    // function video_check(){
    //   if($('.dynamic-video .video_tag').length > 0){
    //     if($('.dynamic-video .video_tag').get(0).paused){
    //     video = ($('.dynamic-video .video_tag').get(0);
    //   if (video != null) {
    //     if (video.pause){
    //       video.play();         
    //     } else {
    //       video.play();
    //     }
    //   }
    //     }else{
    //       setTimeout(function(){
    //         video_check();
    //       },1000);
    //       console.log('%%%%aaaa');
    //     }
    //   }
    // }
    // video_check();
  });
  
  $('body').on('click','.app_shipping_to .gep-switcher',function(e){
    e.preventDefault();
    $('header .gep-switcher').trigger('click');
  });
  // $('body').on('click','.ss__active .ss__list__link, .ss__facet__options .ss__list__option',function(){
  //   setTimeout(function(){
  //     on_load_img_height();
  //   },1000);
  // });
  $("body").on('DOMSubtreeModified', '#searchspring-content .ss__results', function() {
     on_load_img_height();
  });
  if($('.announcement-bar-wrap').length > 0){
    var announcement_slide_speed = parseInt($('.announcement-bar-wrap').attr('data-speed'));
    $('.announcement-bar-wrap').slick({
      infinite: true,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      // fade: true,
      arrows: false,
      dots: false,
      // prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4082 20C15.33 20 15.2525 19.9832 15.1806 19.9506C15.1087 19.918 15.0438 19.8703 14.9898 19.8105L8.2947 12.7445C8.20132 12.6466 8.1272 12.5301 8.07662 12.4018C8.02604 12.2735 8 12.1358 8 11.9968C8 11.8578 8.02604 11.7202 8.07662 11.5918C8.1272 11.4635 8.20132 11.3471 8.2947 11.2492L14.9898 4.1832C15.0447 4.12512 15.11 4.07905 15.1818 4.04761C15.2536 4.01618 15.3305 4 15.4082 4C15.4859 4 15.5629 4.01618 15.6347 4.04761C15.7065 4.07905 15.7717 4.12512 15.8267 4.1832C15.8816 4.24128 15.9252 4.31023 15.955 4.38612C15.9847 4.46201 16 4.54334 16 4.62548C16 4.70762 15.9847 4.78895 15.955 4.86484C15.9252 4.94073 15.8816 5.00968 15.8267 5.06776L9.28103 11.9968L15.8267 18.9259C15.9023 19.015 15.9524 19.1249 15.9711 19.2429C15.9899 19.3609 15.9766 19.4821 15.9328 19.5924C15.889 19.7027 15.8164 19.7976 15.7235 19.866C15.6307 19.9345 15.5213 19.9736 15.4082 19.9789V20Z" fill="currentColor"></path></svg></button>',
      // nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.59175 20C8.47866 19.9947 8.36933 19.9555 8.27647 19.8871C8.18361 19.8187 8.11104 19.7238 8.06721 19.6135C8.02338 19.5031 8.01008 19.3819 8.02886 19.2639C8.04765 19.146 8.09774 19.036 8.17332 18.9469L14.7188 12.0179L8.17332 5.06776C8.06235 4.95046 8 4.79137 8 4.62548C8 4.45959 8.06235 4.3005 8.17332 4.1832C8.28429 4.0659 8.43481 4 8.59175 4C8.74869 4 8.89921 4.0659 9.01018 4.1832L15.7051 11.2492C15.7985 11.3471 15.8726 11.4635 15.9231 11.5918C15.9737 11.7202 15.9998 11.8578 15.9998 11.9968C15.9998 12.1358 15.9737 12.2735 15.9231 12.4018C15.8726 12.5301 15.7985 12.6466 15.7051 12.7445L9.01018 19.8105C8.95621 19.8703 8.8913 19.918 8.81937 19.9506C8.74744 19.9832 8.67 20 8.59175 20Z" fill="currentColor"></path></svg></button>',
      autoplay: true,
      cssEase: 'linear',
      autoplaySpeed: 0,
      speed: announcement_slide_speed,
      // adaptiveHeight: true
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
    
    // Event handler for after slide change
    $('.announcement-bar-wrap').on('afterChange', function(event, slick, currentSlide, nextSlide){
       var slideHeight = $(this).outerHeight(); // Get the outer height of the slide
       $('.site-header-wrapper.site-header--sticky').css('top',slideHeight);
    });
  }

  // announcement-bar popup&overlay height
  var topheight = $(".new-announcement-bar-main").outerHeight();
  $('.ann-menu-popup-overlay').css('top', topheight + "px");
  $('.ann-menu-popup').css('top', topheight + "px");

  $('.site-header-cart-button.mini_cart_button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
    }, 50);
  });
  // $('body').on('click','.cart_overlay, .closeminicart', function(e){
  //   e.preventDefault();
  //   $('body').removeClass('cartOpen');
  // });
  $('body').on('click', '.minicart_add_to_cart', function(r){
    r.preventDefault();
    $('#crt').addClass('loading');
    var id = $(this).attr('data-id');
    var data = 'id='+ id + '&quantity=1';
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(res){
        $.get( "/cart?view=minicart", function( data ) {
          $('#crt').html($(data).find('#minicrt'));
        });
        
        $.get( "/cart.json", function( cart ) {
          if($('.cartDrawer_top .cart_item_count').length > 0 ){
          $('.cartDrawer_top .cart_item_count').text('('+ cart.item_count +')');
          }
          $('[data-header-cart-count]').attr('data-header-cart-count',cart.item_count);
        });
      $('#crt').removeClass('loading');
      },
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        $('.mini_cart_item form').append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(6000).fadeOut();
        $('#crt').removeClass('loading');
      }
    });
  });
  $("#crt").on('click', "a.remove_item", function(r){
    //alert('loading');
    $('#crt').addClass('loading');
    debugger;
    r.preventDefault();
    document.addEventListener('rebuy.remove', function(event){
      debugger;
         $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              id: Number(insurance_product_variant_id),
              quantity:0
            },
            success: function(){
              debugger
              ReloadMiniCart();
            }
          });

     $.get("/cart?view=minicart", function( data ) {
        $('#crt').html($(data).find('#minicrt'));
      });

      $.get( "/cart.json", function( cart ) {
        if($('.cartDrawer_top .cart_item_count').length > 0 ){
         $('.cartDrawer_top .cart_item_count').text('('+ cart.item_count +')');
        }
        $('[data-header-cart-count]').attr('data-header-cart-count',cart.item_count);
      });

      
    });
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('[data-header-cart-count]').attr('data-header-cart-count',c.item_count);
      $.get( "/cart?view=minicart", function( data ) {
        $('#crt').html($(data).find('#minicrt'));
      });
      $.getScript("https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js", function() {
        $('.product_list').slick('refresh');
      }); 
      if($('.cartDrawer_top .cart_item_count').length > 0 ){
        $('.cartDrawer_top .cart_item_count').text('('+ c.item_count +')');
      }
      $('#crt').removeClass('loading');
      // setTimeout(function(){
      //   if(c.item_count == '2' && $('.item_pro_title').hasClass('package_protection') && $('.item_pro_title').hasClass('free_product')){
      //     $('#shipping_protection').trigger('click');
      //   }
      // },500);
    });
  });

$(".affirm-info").on("click", function(e) {
    e.preventDefault();
    $(".info_popup, body").addClass("active-info");
});

$(".info_overlay,.info_popup_close").on("click", function() {
    $(".info_popup, body").removeClass("active-info");
});
  

 $('.complite-look-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: true
      }
    },
     {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, 
  ]
  });

  $('body').on('click','.inquery-btn',function(){
    $('#npHNJUehwR-rvHmkIAYlTA').slideToggle();
  });

   
});
$('.wrap_btn').click(function(e) {
  e.preventDefault();
        var label = $(this);
        var parent = label.parent('.navmenu-item');
        if (parent.hasClass('is-open')) {
            parent.removeClass('is-open');
            $(label).parents('.mobile-nav-panel').removeClass('panel-open');
        } else {
            parent.addClass('is-open');
            $(label).parents('.mobile-nav-panel').addClass('panel-open');
        }
    });
    $('.mob_mega_sub_parent').click(function() {
        var label = $(this);
        var parent = label.parent('.mega_link_inner');
        if (parent.hasClass('is-open')) {
            parent.removeClass('is-open');
        } else {
            parent.addClass('is-open');
        }
    });
    $('.back_parent_menu').click(function() {
        $(this).closest('.navmenu-item').removeClass('is-open');
        $(this).parents('.mobile-nav-panel').removeClass('panel-open');
    });
    $('.back_child_menu').click(function() {
        $(this).closest('.mega_link_inner').removeClass('is-open');
        $(this).parents('.mobile-nav-panel').removeClass('panel-open');
    });


$( document ).ready(function() {


// image-with-slider js start here 
 var active_slider = $('.image-with-slider').hasClass('active-slider-desktop'); 
if ($(window).width() > 767 && active_slider) {
$('.image-with-slider').slick({
  dots: false,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    }
  ]
}); 
}
var active_slider_mobile = $('.image-with-slider').hasClass('active-slider-mobile');   
if ($(window).width() < 768 && active_slider_mobile) {
  
$('.image-with-slider').slick({
  dots: false,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    }
  ]
});
}          
  $('.a4a_insta_grid').slick({
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      }
    },
  ]
 });
  if($('.productgrid--items-page.page_products_slider').length > 0){
    $('.productgrid--items-page.page_products_slider').each(function(){
      var arrow = true, arrow_mob = true;
      if($(this).attr('data-mob-arrow') == 'false'){
        arrow_mob = false;
      }
      if($(this).attr('data-desktop-arrow') == 'false'){
        arrow = false;
      }
      $(this).slick({
        dots: false,
        arrows: arrow,
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              arrows: arrow_mob
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              arrows: arrow_mob
            }
          }
        ]
       });
    });
  }
  
  $('.note-list-wrapper .testimonial_has_list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#6D6D6D" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
  });
  
  $('.product_list').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: false,
  arrows: false
});
$('body').on('click','.inquiry_popup', function(e) {
  e.preventDefault();
  var form = $(this).closest('form');
  var title = form.find('[data-variants] option:checked').attr('data-variant-title');
  var url = form.find('[data-variants] option:checked').attr('data-product-url');
  var img = form.find('[data-variants] option:checked').attr('data-variant-img');
  $('.inq_price_popup .price_pro_name h5').text(title);
  $('.inq_price_popup .price_pro_name input.product_title').val(title);
  $('.inq_price_popup .price_pro_name input.product_url').val(url);
  $('.inq_price_popup .price_pro_img img').attr('src',img);
  $(".inq_price_popup, body").addClass("active-popup");
});
  $('body').on('click','.popup_overlay, .inq_popup_close', function(e) {
    $(".inq_price_popup, body").removeClass("active-popup");
});
  $('body').on('click','.custom-error-message[data-message-banner] .message-banner--close',function(){
    $(this).closest('.custom-error-message[data-message-banner]').remove();
  });

  function swymCallbackFn(swat) {
    // your API calls go here
    attachNotifyMeEvents();
    function attachNotifyMeEvents() {
            var swymNotifyMeBtn = document.querySelectorAll(".swym-custom-watchlist");
      swymNotifyMeBtn.forEach(function(btn) {
        btn.addEventListener("click", addToWatchlist);
        btn.classList.add("swym-loaded");
      });
    }
    function addToWatchlist(eventObj) {
      eventObj.preventDefault();
      var productId = +eventObj.target.getAttribute("data-product-id");
      var variantId = +eventObj.target.getAttribute("data-variant-id");
      var du = eventObj.target.getAttribute("data-url");
      var params = {
        empi: productId,
        epi: variantId,
        du: du
      };
      swat.getProductDetails(params, function(productJSON) {
        productJSON.variants.forEach(function(v) {
          if (v.id == variantId) {
            params.pr = SwymUtils.formatProductPrice(v.price);
            params.iu = productJSON.featured_image;
            params.et = 8;
            swat.addToWatchList(eventObj, params, function(e) {
              console.log("Subscribed to product!", e);
            }); // Shows Subscribe me.
            return;
          }
        });
      });
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
 }
  window.SwymCallbacks.push(swymCallbackFn);

  // $('body').on('change','.customizer_validation, .customizer_validation_block .option-value-input:checked, .customizer_validation_number, .customizer_validation_number_block .option-value-input',function(){
  //   var max_val = $(this).val();
  //   if(!isNaN(max_val)){
  //   $('.product-customizer-option [type="text"]').attr('maxlength',max_val).val('');
  //   }
  // });

let totalMaxLength = 0;

function setCombinedMaxLength() {
  const $selected = $('.customizer_validation, .customizer_validation_block .option-value-input:checked, .customizer_validation_number, .customizer_validation_number_block .option-value-input:checked');
  const max_val = parseInt($selected.val(), 10);
  console.log(max_val,'max_val----===-dfdfdfdfdfdfdf')
  if (!isNaN(max_val)) {
    totalMaxLength = max_val;

    // Reset all input fields
    $('.product-customizer-option [type="text"]').each(function () {
      $(this).val('').attr('maxlength', totalMaxLength);
    });
  }
}

function enforceCombinedCharacterLimit() {
  const $selected = $('.customizer_validation:checked, .customizer_validation_block .option-value-input:checked, .customizer_validation, .customizer_validation_number, .customizer_validation_number_block .option-value-input');
  const max_val = parseInt($selected.val(), 10);
  if (!isNaN(max_val)) {
    const $inputs = $('.product-customizer-option [type="text"]');
    let totalUsed = 0;
  
    // Calculate total characters used
    $inputs.each(function () {
      totalUsed += $(this).val().length;
    });
  
    // Adjust each input's maxlength dynamically
    $inputs.each(function () {
      const ownLength = $(this).val().length;
      const remaining = totalMaxLength - (totalUsed - ownLength);
      $(this).attr('maxlength', remaining >= 0 ? remaining : 0);
    });
  }
}
  // Run on load
  setCombinedMaxLength();

  // Bind change event
  $('body').on('change', '.customizer_validation, .customizer_validation_block .option-value-input:checked, .customizer_validation_number, .customizer_validation_number_block .option-value-input', function () {
    setCombinedMaxLength();
  });

  // Bind input event for live enforcement
  $('body').on('input', '.product-customizer-option [type="text"]', function () {
    enforceCombinedCharacterLimit();
  });
  
    let utmId = '';

  // Check if utm object and utmId exist
  if (window.utm && window.utm.utmId) {
    utmId = window.utm.utmId;

    // Check if the utm_id is present in the actual URL
    if (window.location.href.indexOf(utmId) > -1) {
      $('.black_bf_msg.utm_message').show();
      $('.price--main .money').css('text-decoration', 'line-through');
      let discount_amount = $('.black_bf_msg.utm_message').attr('data-utm-discount');
      $('.price--main.price_affirm_set').after(`<div class="discount-amount">NOW ${discount_amount}</div>`);

    }
  }

  function slider_arrow() {
    $('.product-slider-list').each(function() {
        var $slider = $(this);
        var sl_arrow = $slider.find('.productitem--image').first().outerHeight() / 2;

        $slider.find('.slick-arrow').css('top', sl_arrow);
    });
  }
  slider_arrow();
  $(window).on('resize', function() {
      slider_arrow();
  });


Fancybox.bind('[data-fancybox="product-gallery"]', {
  animated: false,
  showClass: false,
  hideClass: false,

  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: ['close']
    }
  },

  Thumbs: false,
  preload: 0
});

 function initMobileSlider() {

    if ($(window).width() < 1025) {

      if (!$('.mobile_product_gallery').hasClass('slick-initialized')) {

        $('.mobile_product_gallery').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          adaptiveHeight: true,
          infinite: false,
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#000000" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none"><path d="M21 41L1 21L21 1" stroke="#000000" stroke-miterlimit="20" stroke-linecap="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              }
            },
          ]
        });

      }

    } else {

      if ($('.mobile_product_gallery').hasClass('slick-initialized')) {
        $('.mobile_product_gallery').slick('unslick');
      }

    }

  }

  initMobileSlider();

  $(window).on('resize', function () {
    initMobileSlider();
  });

    
});
$('body').on('click', '.inq_price_popup .inq_price_form .inq_price_btn' ,function(){
  var fname = $(this).closest('.inq_price_form').find('#fname').val();
  var lname = $(this).closest('.inq_price_form').find('#lname').val();
  var email = $(this).closest('.inq_price_form').find('#email').val();
  var x = false;
  $(this).closest('.inq_price_form').find('.inquiry-error').remove();
  if(fname == ''){
    $(this).closest('.inq_price_form').find('#fname').after("<p class='error inquiry-error'>First Name Can't be blank</p>");
    x = true;
  }else{
    x= false;
  }
  if(lname == ''){
    $(this).closest('.inq_price_form').find('#lname').after("<p class='error inquiry-error'>Last Name Can't be blank</p>");
    x = true;
  }else{
    x= false;
  }
  if(email == ''){
    $(this).closest('.inq_price_form').find('#email').after("<p class='error inquiry-error'>Email Can't be blank</p>");
    x = true;
  }else{
    x= false;
  }
  if(x){
    return false;
  }
});

$('.question-link').click(function(e){
  e.preventDefault();
  var id = $(this).attr('href');
  $('.faq_main').hide();
  $(id).show();
  $(window).scrollTop(0);
});

$('.return_faq_btn').click(function(e){
    e.preventDefault();
  $(this).parents('.container_cm').hide();
  $('.faq_main').show();
  $(window).scrollTop(0);
});

// jQuery.get('/browsing_context_suggestions.json', (d) => { 
// 	var country_handle = d.detected_values.country.handle;
//     if(country_handle == 'US'){
//       $('.affirm-as-low-as-custom').css('display','flex');
//     }else{
//       $('.affirm-as-low-as-custom').hide();
//     }
// });
$('body').on('click','.get-started-cta',function(){
  window.location.href = "https://www.efcollection.com/pages/bridal-consultation-form";
});


// 17-08-2023 popup js start
$('body').on('click','.product-form--customize',function(e){
  e.preventDefault();
  var custom_title = $(this).attr('data-title');
  $('.product-popup-inner h2 span').text(custom_title);
  $(".product-popup, body").addClass("active-popup");
});
$('body').on('click','.popup_overlay, .product_popup_close', function(e) {
  e.preventDefault();
  $(".product-popup, body").removeClass("active-popup");
});

  // header shopby hover
  $(document).on("mouseenter",".top-menu",function(){
    // let type = $(this).attr("data-type");
    $(this).siblings().removeClass("active");
    if($('.top-menu').hasClass('mega-menu') == true){
      $(this).addClass("active");
    }else{
      $(this).removeClass("active");
    }
    
    
  });
  $(document).on("mouseleave",".ann-menu-popup-inner",function(){
    $(".top-menu").removeClass("active");
    // $(this).removeClass("megamenu-active");
  });

  //--*** Shop The Look js start ***--//
  
$('body').on("click", '.flayout_close, .action--link', function(e) {
  e.preventDefault();
  e.stopPropagation(); // prevent bubbling to outer click handlers
  $('body').removeClass('shop-active');
  $('.flayout').removeClass('flyout-active');
  $('.inner-option-flayout').removeClass('inner-active');
  setTimeout(() => {
    $(".flayout").removeClass("flyout-active-second");
  }, 500);
});

  $('body').on("click",'.flayout_overlay',function(e){
    e.preventDefault();
    if($('.inner-option-flayout').hasClass('inner-active')){
       $('.inner-option-flayout').removeClass('inner-active');
    }else{
      $('body').removeClass('shop-active');
      $('.flayout').removeClass('flyout-active');
    }
  });
  

  $('body').on("click",'.shop_look_btn',function(e){
    e.preventDefault();
    $('body').addClass('shop-active');
    var product_main_id = $(this).attr('data-product-id');
    $('.flayout').removeClass('flyout-active');
    $('.flayout[data-flayout-id="'+product_main_id+'"]').addClass("flyout-active flyout-active-second");
  });

  $('body').on('click', '.sparkling_blog', function(e){
      var $button = $(this).find('.product-set__open');
      // Stop if button doesn't exist
      if (!$button.length) {
          return;
      }
      $('body').addClass('shop-active');
      var product_main_id = $button.attr('data-product-id');
      $('.flayout').removeClass('flyout-active');
      $('.flayout[data-flayout-id="' + product_main_id + '"]').addClass('flyout-active flyout-active-second');
  });


   // $('body').on("click",'.flayout_select',function(e){
   //   e.preventDefault();
   //   $(this).parents('.flayout_cart_item').find('.inner-option-flayout').addClass('inner-active');
   // });
   
   // $('body').on("click",'.flyout_back_arrow',function(e){
   //   e.preventDefault();
   //   $(this).parents('.inner-option-flayout').removeClass('inner-active');
   // });

   $('body').on('click','.flyout_form .add-to-cart-btn',function(e){
     e.preventDefault();
     var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).closest('form').serialize(),
      dataType: 'json',
      success: function(data){
      $('.flyout-active .flayout_product_body').find('.flayout_body_heading').show(); 
      var cur_product_handle = data.handle; 
      $('.flayout.flyout-active').find('[data-item-handle="' + cur_product_handle + '"]').remove();
      setTimeout(function(){
      var all_product_add = parseInt($('.flayout.flyout-active').find('.flayout_cart_item').length);
        if(all_product_add == 0){
            $('.flayout.flyout-active').find('.flayout_product_body').hide();
            $('.flayout.flyout-active').find('.product-set__actions').show();
          } 
        },500);
        
      $('.flyout-active .flyout_footer').addClass('notify-active');
      setTimeout(function() {
        $('.flyout_footer').removeClass('notify-active');
      }, 5000);
      $('.flyout-active .flyout_product_choice').show();
        let flyoutChoice = `
        <div class="flyout_choice_item">
          <a href="${data.url}" class="flyout_choice_img">
            <img src="${data.featured_image.url}">
          </a>
          <div class="choice_detail_main">
            <div class="choice_cart_detail">
              <a href="${data.url}">
              <h6>${data.product_title}</h6>
              </a>
              <span>${Shopify.formatMoney(data.line_price, '')}</span>
              <p>${data.variant_title ? data.variant_title : ''}</p>
            </div>
          </div>
        </div>`;

        $('.flayout.flyout-active').find('.flyout_choice_main').append(flyoutChoice);
         $.get( "/cart?view=minicart", function( data ) {
          $('#crt').html($(data).find('#minicrt'));
        });
        $.get( "/cart.json", function( cart ) {
          if($('.cartDrawer_top .cart_item_count').length > 0 ){
            $('.cartDrawer_top .cart_item_count').text('('+ cart.item_count +')');
          }
          $('[data-header-cart-count]').addClass('visible').attr('data-header-cart-count',cart.item_count);
        });
        document.addEventListener('rebuy.add', function(event){
          $.get("/cart?view=minicart", function( data ) {
            $('#crt').html($(data).find('#minicrt'));
          });
          $.get( "/cart.json", function( cart ) {
            if($('.cartDrawer_top .cart_item_count').length > 0 ){
             $('.cartDrawer_top .cart_item_count').text('('+ cart.item_count +')');
            }
            $('[data-header-cart-count]').attr('data-header-cart-count',cart.item_count);
          });
        });
      },
      error: function() {
      }
    };
    $.ajax(params);
    return false;
  });

  // var shopArr = [];
  // $('body').on('click','.ss__inline-banner .our_coll_top, our_coll_top.stl_on',function(e){
  //   e.preventDefault();
  //   $('body').addClass('shop-active');
  //   $('.flyout_product_choice').hide();
  //   $('.flyout_choice_main').empty();
  //   $('.flayout_body_heading').hide();
  //   $('.flayout_item_main').empty();
  //   $('.product-set__actions').hide();
  //   $('.flayout_product_body').show();
  //   var profile_tag = $(this).find('.product-set__open.collection-look').attr('data-profile-tag');
   
  //   $('.flayout').addClass('flyout-active'); 
  //     const settings = {
  //       async: true,
  //       crossDomain: true,
  //       url: `https://6wbv3x.a.searchspring.io/boost/6wbv3x/recommend?tags=${profile_tag}&limits=20`,
  //       method: 'GET',
  //       headers: {
  //         accept: 'application/json'
  //       }
  //     };
  //     $.ajax(settings).done(function (response) {
  //         console.log(response);
  //        // Clear the array before each new click
  //         shopArr = [];
  //        // Iterate over each item in the results array
  //         $(response[0].results).each(function(index, item) {
  //          var shop_handle = item.attributes.handle;
  //          shopArr.push(shop_handle);
  //         });
  //        // Iterate over shopArr and make a get request for each value
  //        $.each(shopArr, function(index, handle) {
  //         $.get(`https://www.efcollection.com/products/${handle}?view=alternative-shop`, function(data) {
  //           $('.flayout_item_main').append(data);
  //       });
  //     });
  //   });  
  // });

  //--*** Shop The Look js end ***--//

  $('.charm_tag').on('click', function(event) {
        event.stopPropagation(); // Prevent event from propagating to parent
        
        // Scroll to the specific section (replace '#specific-section' with your target element's ID or class)
         $('html, body').animate({
            scrollTop: $(".product-list-slider-wp").offset().top - 150
        }, 2000);
    });

  // 6-11-2024
    var Swipes = new Swiper('.gift_block_grid', {
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next.gift_block_arrows',
            prevEl: '.swiper-button-prev.gift_block_arrows',
        },
         breakpoints: {
          1080: {
              slidesPerView: 4,
              spaceBetweenSlides: 60
          },
          640: {
              slidesPerView: 3,
              spaceBetweenSlides: 40
          }
        }
    });

   // 7-11-2024
    var three_banner_slider = new Swiper('.three-banner-slider', {
        slidesPerView: 1.23,
        spaceBetween: 10,
         breakpoints: {
          767: {
              slidesPerView: 2
          }
        }
    });

    // 7-11-2024
    var three_banner_slider = new Swiper('.plp_new_slider ', {
        initialSlide: window.activePlp,
        slidesPerView: 2,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next.plp_new_slider_arrow',
            prevEl: '.swiper-button-prev.plp_new_slider_arrow',
        },
        breakpoints: {
          1440: {
              slidesPerView: 4,
          },
          767: {
              slidesPerView: 4,
          },
          575: {
              slidesPerView: 3,
          }
        }
    });

    // 03-03-2025 Style With Wrraper Slider [PDP Page]
    var swiper = new Swiper(".pdpSlider", {
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next.pdp-slider-arrow",
            prevEl: ".swiper-button-prev.pdp-slider-arrow",
        },
        breakpoints: {
            1441: {
                slidesPerView: 3,
            },
            720: {
                slidesPerView: 2,
            },
            641: {
                slidesPerView: 4,
            },
            481: {
                slidesPerView: 3,
            },
            320: {
                slidesPerView: 2,
            }
        }
    });
    
$('body').on('click','#newsletter-form button',function(){
var email = $(this).closest('form').find('[name="email"]').val();
var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
if(!regex.test(email)) {
$(this).parents('.holiday-newsletter-section').find('.klaviyo_messages .error_message').text('Please add valid email id').show();
 return false;
}else{
$(this).parents('.holiday-newsletter-section').find('.klaviyo_messages .error_message').text('').hide();
 return true;
}
});
  KlaviyoSubscribe.attachToForms('#newsletter-form', {
    hide_form_on_success: false,
    success_message: "You are subscribed successfully!!",
    success: function ($form) {
      setTimeout(function(){
        $form.find('.success_message').text('');
      },5000);
    }
  });

function slider_arrow() {
    var sl_arrow = $(".productitem--image").outerHeight() / 2;
    $(".product-slider-list .slick-arrow").css("top", sl_arrow);
}
slider_arrow();


// document.addEventListener('DOMContentLoaded', function () {
//   const firstVideoFigure = document.querySelector(
//     '.product-gallery--media.product-gallery--video.is-selected, .product-gallery--media.product-gallery--video[data-gallery-index="0"]'
//   );

//   if (!firstVideoFigure) return;

//   const videoEl = firstVideoFigure.querySelector('video');
//   if (!videoEl) return;

//   // Mobile-safe autoplay requirements
//   videoEl.setAttribute('playsinline', '');
//   videoEl.setAttribute('webkit-playsinline', '');
//   videoEl.muted = true;
//   videoEl.setAttribute('muted', '');

//   function playVideo() {
//     // Native play
//     videoEl.play().catch(() => {
//       // Try Plyr if available
//       const plyr = videoEl.plyr || (window.Plyr ? new Plyr(videoEl, { muted: true, loop: true }) : null);
//       if (plyr && typeof plyr.play === 'function') plyr.play().catch(() => {});
//     });
//   }

//   // Try immediately
//   playVideo();

//   // Retry when Plyr is ready
//   if (videoEl.plyr && typeof videoEl.plyr.on === 'function') {
//     videoEl.plyr.on('ready', playVideo);
//   }

//   // Fallback: on first user gesture
//   const gesturePlay = () => { playVideo(); window.removeEventListener('click', gesturePlay); };
//   window.addEventListener('click', gesturePlay, { once: true });
// });




var swiper = new Swiper(".our_coll_grid", {
  slidesPerView: 1.4,
  spaceBetween: 10, 
  breakpoints: {
    576: {
      slidesPerView: 2.1
    },
    1024: {
      slidesPerView: 3
    }
  }
});

var swiper = new Swiper(".shipping_slider", {
  effect: "fade",
  slidesPerView: 1,
  spaceBetween: 0, 
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    767: {
      effect: "none",
      slidesPerView: 3,
      spaceBetween: 20,
      loop: false,
      autoplay: false,
    }
  }
});

  function footerAccordion() {

    if ($(window).width() < 1024) {

      $('.site-footer-block-menu .site-footer-block-title')
        .off('click.footerAccordion')
        .on('click.footerAccordion', function () {

          const $parent = $(this).closest('.site-footer-block-menu');
          const $content = $parent.find('.site-footer-block-content.accordion--content');

          $parent.toggleClass('active');

          if ($parent.hasClass('active')) {
            $content.css('max-height', $content[0].scrollHeight + 'px');
          } else {
            $content.css('max-height', 0);
          }
        });

    } else {
      // Remove accordion behavior on desktop
      $('.site-footer-block-menu .site-footer-block-title').off('click.footerAccordion');

      $('.site-footer-block-menu')
        .removeClass('active')
        .find('.site-footer-block-content.accordion--content')
        .css('max-height', '');
    }
  }

  footerAccordion();

  $(window).on('resize', function () {
    footerAccordion();

    if ($(window).width() < 1024) {
      $('.site-footer-block-menu.active').each(function () {
        const $content = $(this).find('.site-footer-block-content.accordion--content');
        $content.css('max-height', $content[0].scrollHeight + 'px');
      });
    }
  });

function initMegaMenuAccordion() {

  if ($(window).width() >= 1024) {
    $('.menu___list')
      .css('height', '')
      .removeClass('active');

    $('.mob_mega_sub_parent.mega___list_title')
      .removeClass('active')
      .off('click.megaAccordion');

    return;
  }

  // Mobile: all open by default
  $('.menu___list').addClass('active');
  $('.mob_mega_sub_parent.mega___list_title').addClass('active');

  $('.mob_mega_sub_parent.mega___list_title')
    .off('click.megaAccordion')
    .on('click.megaAccordion', function () {

      const $title = $(this);
      const $content = $title.next('.menu___list');

      if ($content.hasClass('active')) {
        // Close
        $content.removeClass('active').css('height', 0);
        $title.removeClass('active');
      } else {
        // Open
        $content.addClass('active');
        $content.css('height', $content[0].scrollHeight + 'px');
        $title.addClass('active');
      }
    });
}

initMegaMenuAccordion();

$(window).on('resize', function () {
  initMegaMenuAccordion();
});









